<div class="">
  <div class="mx-auto">
    <div class="flex justify-between items-center mb-10">
      <h2 class="text-4xl font-bold text-gray-800">Department Form</h2>
    </div>
    <form
      class="bg-white rounded-2xl shadow p-10"
      (ngSubmit)="onSubmit()"
      #departmentForm="ngForm"
      autocomplete="off"
    >
      @if (department().id) {
      <div class="flex items-center gap-x-4 mb-8">
        <div class="text-3xl font-bold text-gray-700">ID:</div>
        <div class="text-3xl text-gray-700">{{ department().id }}</div>
      </div>
      }

      <div class="mb-8">
        <label for="name" class="block text-2xl font-bold text-gray-700 mb-2"
          >Name
          <span class="ml-2 font-normal text-red-600">*</span>
        </label>
        <input
          id="name"
          name="name"
          type="text"
          class="w-full max-w-2xl px-4 py-2 border border-gray-300 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
          [(ngModel)]="department().name"
          placeholder="Enter department name."
          required
        />
      </div>
      <div class="mb-8">
        <label
          for="description"
          class="block text-2xl font-bold text-gray-700 mb-2"
          >Description
          <span class="ml-2 font-normal text-red-600">*</span>
        </label>
        <textarea
          id="description"
          name="description"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
          [(ngModel)]="department().description"
          rows="4"
          placeholder="Enter department description."
          required
        ></textarea>
      </div>
      <div class="flex gap-4 mt-8">
        <button
          type="submit"
          [disabled]="departmentForm.invalid"
          class="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg text-lg font-semibold transition"
        >
          Save
        </button>
        <button
          type="button"
          (click)="onCancel()"
          class="bg-gray-200 hover:bg-gray-300 text-gray-700 px-6 py-2 rounded-lg text-lg font-semibold transition"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>
